export default "__VITE_ASSET__C_1CsHOn__"